export const columns = t => [
  { label: t.sourceId, value: 'sourceId' },
  { label: t.notificationNumber, value: 'notificationNumber' },
  { label: t.serviceOrderNumber, value: 'serviceOrderNumber' },
  { label: t.serialNumber, value: 'serialNumber' },
  { label: t.jobTypeDescription, value: 'jobTypeDescription' },
  { label: t.customerName, value: 'customerName' },
];

export const smallScreens = ['xs', 'sm'];



// WEBPACK FOOTER //
// ./src/views/ImportJob/constants.js